import "./App.css";
import React from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import ScrollToTop from "./components/Common/ScrollTop";
import X01LandingPageDesktop from "./components/Desktop/LandingPage";
import X01LandingPageMobile from "./components/Mobile/LandingPage";
import LandingPageTablet from "./components/Tablet/LandingPage";
import X02AboutPageDesktop from "./components/Desktop/AboutPage";
import X02AboutPageMobile from "./components/Mobile/AboutPage";
import X02AboutPageTablet from "./components/Tablet/AboutPage";
import X06InsightsPageDesktop from "./components/Desktop/InsightPage";
import X06InsightsPageMobile from "./components/Mobile/InsightPage";
import X06InsightsPageTablet from "./components/Tablet/InsightPage";
import BlogPageDesktop from "./components/Desktop/BlogPage";
import X05GalleryPageMobile from "./components/Mobile/BlogPage";
import X04PortfolioDetailPage from  "./components/Desktop/PortfolioDetailPage"
import X03PortfolioPage from "./components/Desktop/PortfolioPage";
import X03PortfolioPageMobile from "./components/Mobile/PortfolioPage";
import X03PortfolioPageTablet from "./components/Tablet/PortfolioPage";
import X10ContactUsPageDesktop from "./components/Desktop/ContactUs";
import X07InsightsPageDETAILSDesktop from "./components/Desktop/InsightDetailPage";
import X09BlogsDetailsPageDesktop from "./components/Desktop/BlogDetailPage";
import X11FAQsPageDesktop from "./components/Desktop/FAQpage";
import X05GalleryPageDesktop from "./components/Desktop/GalleryPage";
import X09BlogsDetailsPageMobile from "./components/Mobile/BlogDetailPage";
import X07InsightsPageDETAILSMobile from "./components/Mobile/InsightDetailPage";
import X10ContactUsPageMobile from "./components/Mobile/ContactUs";
import X11FAQsPageMobile from "./components/Mobile/FAQPage";
import GalleryPageMobile from "./components/Mobile/GalleryPage";
import X05GalleryPageTablet from "./components/Tablet/GalleryPage";
import X09BlogsDetailsPageTablet from "./components/Tablet/BlogDetailPage";
import X10ContactUsPageTablet from "./components/Tablet/ContactUs";
import BlogPageTablet from "./components/Tablet/BlogPage";
import X11FAQsPageTablet from "./components/Tablet/FAQPage";
import X07InsightsPageDETAILSTablet from "./components/Tablet/InsightDetailPage";
import { BBMP, BWSSB, BESCOM, Procedure, Vaastu, ByeLaws, TipsIdeas, Budget } from "./components/static/data/InsightDetailsPage.js";
import X12PackagesDetailPageTablet from "./components/Tablet/PackageDetailPage";
import X12PackagesDetailPageDesktop from "./components/Desktop/PackageDetailPage";
import X12PackagesDetailPageMobile from "./components/Mobile/PackageDetailPage";
//import { useParams } from 'react-router-dom';
 
function App() {
  // let { categoryid, packageid } = useParams();
  return (
    <Router>
      <ScrollToTop>
      <Switch>
        <Route path="/:path(|home)">
          <div className="desktop-only">
            <X01LandingPageDesktop/>
          </div>
          <div className="mobile-only">
            <X01LandingPageMobile/>
          </div>
          <div className="tablet-only">
            <LandingPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|about)">
          <div className="desktop-only">
            <X02AboutPageDesktop/>
          </div>
          <div className="mobile-only">
            <X02AboutPageMobile/>
          </div>
          <div className="tablet-only">
            <X02AboutPageTablet/>
          </div>
        </Route>
        <Route path="/:path(|blog)">
        <div className="desktop-only">
            <BlogPageDesktop/>
          </div>
          <div className="mobile-only">
            <X05GalleryPageMobile/>
          </div>
          <div className="tablet-only">
            <BlogPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|blogdetails)">
        <div className="desktop-only">
            <X09BlogsDetailsPageDesktop/>
          </div>
          <div className="mobile-only">
            <X09BlogsDetailsPageMobile/>
          </div>
          <div className="tablet-only">
            <X09BlogsDetailsPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|insight)">
        <div className="desktop-only">
            <X06InsightsPageDesktop/>
          </div>
          <div className="mobile-only">
            <X06InsightsPageMobile/>
          </div>
          <div className="tablet-only">
            <X06InsightsPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|projectdetails)/:projectid">
          <div>
            <X04PortfolioDetailPage/>
          </div>
        </Route>
        
        <Route path="/:path(|project)">
        <div className="desktop-only">
            <X03PortfolioPage/>
          </div>
          <div className="mobile-only">
            <X03PortfolioPageMobile/>
          </div>
          <div className="tablet-only">
            <X03PortfolioPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|contactus)">
        <div className="desktop-only">
            <X10ContactUsPageDesktop/>
          </div>
          <div className="mobile-only">
            <X10ContactUsPageMobile/>
          </div>
          <div className="tablet-only">
            <X10ContactUsPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-bbmp)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...BBMP}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...BBMP}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...BBMP}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-bwssb)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...BWSSB}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...BWSSB}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...BWSSB}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-bescom)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...BESCOM}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...BESCOM}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...BESCOM}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-procedure)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...Procedure}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...Procedure}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...Procedure}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-vaastu)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...Vaastu}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...Vaastu}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...Vaastu}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-byelaws)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...ByeLaws}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...ByeLaws}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...ByeLaws}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-tips&ideas)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...TipsIdeas}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...TipsIdeas}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...TipsIdeas}/>
          </div>
        </Route>

        <Route path="/:path(|insightdetails-budget)">
        <div className="desktop-only">
            <X07InsightsPageDETAILSDesktop {...Budget}/>
          </div>
          <div className="mobile-only">
            <X07InsightsPageDETAILSMobile {...Budget}/>
          </div>
          <div className="tablet-only">
            <X07InsightsPageDETAILSTablet {...Budget}/>
          </div>
        </Route>

        <Route path="/:path(|faq)">
          <div className="desktop-only">
            <X11FAQsPageDesktop/>
          </div>
          <div className="mobile-only">
            <X11FAQsPageMobile/>
          </div>
          <div className="tablet-only">
            <X11FAQsPageTablet/>
          </div>
        </Route>

        <Route path="/:path(|video)">
          <div className="desktop-only">
            <X05GalleryPageDesktop/>
          </div>
          <div className="mobile-only">
            <GalleryPageMobile/>
          </div>
          <div className="tablet-only">
            <X05GalleryPageTablet/>
          </div>
        </Route>
        <Route path={`${`/:path(|packagedetails)/:categoryid/:packageid`}`}>
          <div className="desktop-only">
            <X12PackagesDetailPageDesktop/>
          </div>
          <div className="tablet-only">
            <X12PackagesDetailPageTablet/>
          </div>
          <div className="mobile-only">
            <X12PackagesDetailPageMobile/>
          </div>
        </Route>
        <Route path={`${`(/packagedetailsftr)/:categoryid/:packageid`}`}>
          <div className="desktop-only">
            <X12PackagesDetailPageDesktop/>
          </div>
          <div className="tablet-only">
            <X12PackagesDetailPageTablet/>
          </div>
          <div className="mobile-only">
            <X12PackagesDetailPageMobile/>
          </div>
        </Route>
      </Switch>
      </ScrollToTop>
    </Router>
  );
}

export default App;

